import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12c0-2.72 1.22-5.16 3.13-6.81A7.43 7.43 0 007.5 4.5C3.36 4.5 0 7.86 0 12c0 4.14 3.36 7.5 7.5 7.5 1.12 0 2.18-.25 3.13-.69A8.987 8.987 0 017.5 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5 6a6 6 0 100 12 6 6 0 000-12zM9 12a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2702_3266"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12c0-2.72 1.22-5.16 3.13-6.81A7.43 7.43 0 007.5 4.5C3.36 4.5 0 7.86 0 12c0 4.14 3.36 7.5 7.5 7.5 1.12 0 2.18-.25 3.13-.69A8.987 8.987 0 017.5 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5 6a6 6 0 100 12 6 6 0 000-12zM9 12a7.5 7.5 0 1115 0 7.5 7.5 0 01-15 0z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2702_3266"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 24c0-5.44 2.44-10.32 6.26-13.62C19.36 9.5 17.24 9 15 9 6.72 9 0 15.72 0 24c0 8.28 6.72 15 15 15 2.24 0 4.36-.5 6.26-1.38C17.44 34.32 15 29.44 15 24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M33 12c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zM18 24c0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15z",
    clipRule: "evenodd"
  }))
};
export var EffectActive = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});